import React from 'react';
import { ZigZagComponent } from '@sapientpro/sapientpro-data-models';
import classnames from 'classnames';
import AnimatedTitle from '../../components/AnimatedTitle';
import InfoCard from './InfoCard/InfoCard';
import styles from './Info.module.scss';

type InfoProps = {
  data: ZigZagComponent,
};

const Info = ({ data }: InfoProps) => (
  <div className={styles.info}>
    <div className={styles.hero}>
      <h1 className={styles.title}><AnimatedTitle title={data.title} /></h1>
      <p className={styles.subtitle}>
        {data.description}
      </p>
    </div>
    <div className={classnames('container', styles.content)}>
      <div className={styles.info__content}>
        {data.zigzagContent.map(zigzagItem => (
          <InfoCard
            data={zigzagItem}
            key={zigzagItem.id}
          />
        ))}
      </div>
    </div>
  </div>
);
export default Info;
